import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CountryTimeZones } from "../models/country-timezones.model";
import { ConfigurationService } from "./configuration.service";
import { DataService } from "./data.service";

@Injectable()
export class TimeZoneService {
  public tenantTimeZone: string;
  private ePermitsUrl = "";

  constructor(
    private service: DataService,
    private configurationService: ConfigurationService,
  ) {
    this.tenantTimeZone = "GMT";

    if (this.configurationService.isReady) {
      this.ePermitsUrl = this.configurationService.serverSettings.ePermitsUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(
        (x) => (this.ePermitsUrl = x?.ePermitsUrl),
      );
    }
  }

  getCountryTimeZones(): Observable<CountryTimeZones[]> {
    const url = `${this.ePermitsUrl}/api/v1/regionalsettings/countrytimezones`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }
}
